import React from 'react';
import { styles } from '../AuthWrapper.styles';
import type { AuthFormState } from '../../hooks/useAuthForm';

const ConfirmForm: React.FC<{ form: AuthFormState }> = ({ form }) => {
  const { email, confirmationCode, setConfirmationCode, isSubmitting, handleConfirmSignUp, setAuthMode } = form;

  return (
    <form onSubmit={handleConfirmSignUp} style={styles.form}>
      <p style={styles.confirmText}>
        We've sent a confirmation code to <strong>{email}</strong>. Please enter it below.
      </p>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="code">Confirmation Code</label>
        <input
          id="code"
          type="text"
          value={confirmationCode}
          onChange={(e) => setConfirmationCode(e.target.value)}
          placeholder="Enter 6-digit code"
          required
          maxLength={6}
          style={styles.input}
          disabled={isSubmitting}
        />
      </div>
      <button
        type="submit"
        style={{
          ...styles.button,
          ...(isSubmitting ? styles.buttonDisabled : {}),
        }}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Verifying...' : 'Verify'}
      </button>
      <button type="button" style={styles.linkButton} onClick={() => setAuthMode('signup')}>
        Back to Sign Up
      </button>
    </form>
  );
};

export default ConfirmForm;
